<div>
  <label class="block">
    <app-label
      [text]="label"
      [required]="required"
    >
    </app-label>
    <div class="relative bg-white rounded-lg h-48">
      <select
        (change)="handleChange()"
        class="
          absolute
          bg-transparent
          border-0
          cursor: pointer;
          inset-0
          max-w-full
          m-0
          outline: none;
          p-12
          text-black
          z-fg
        "
        [formControl]="control"
      >
        <ng-container *ngFor="let option of options">
          <option
            [ngValue]="option.value"
          >
            {{ option.label }}
          </option>
        </ng-container>
      </select>
      <div class="pointer-events-none absolute right-12 w-12 top-1/2 transform -translate-y-1/2">
        <app-triangle></app-triangle>
      </div>
    </div>
    <app-required-message [text]="requiredErrorMessage"></app-required-message>
  </label>
</div>
